// App.js

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Header from './components/Header';
import SideBar from './components/SideBar';
import Content from './components/Content';
import Push from './components/Push';
import Inquiry from './components/Inquiry';
import Notice from './components/Notice';
import FAQ from './components/FAQ';
import Terms from './components/Terms';
import PayTerms from './components/PayTerms';
import Privacy from './components/Privacy';
import Legal from './components/Legal';
import Banner from './components/Banner';

import Policy from './components/Policy';

import Payments from './components/Payments';
import Purchase from './components/Purchase';
import Product from './components/Product';
import Users from './components/Users';
import Devices from './components/Devices';

import PicturePurchase from './components/PicturePurchase';

import PurchaseRegList from './components/PurchaseRegList';
import PurchaseReg from './components/PurchaseReg';

import GoodsProduct from './DigitalGoods/GoodsProduct';
import GoodsDownload from './DigitalGoods/DownloadList';

import MediaReply from './components/MediaReply';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      menu: 'main',
      control: true,
      onLogin: false
    }
  }

  onMenuClick = (name) => {
    // alert('name');
    this.setState({ menu: name });
    if( name == 'logout' )
      this.setState({login: false , control: false});
  }

  onLogin = (val) => {
    if (val == true) {
      this.setState({ control: val });
      alert('login OK');
      this.setState({ login: true });
    } else {
      this.setState({ control: val });
      alert('login OK');
      this.setState({ login: true });
    }

  }

  render() {
    return (
        <div>
          <Header />
          <SideBar onPress={this.onMenuClick} login={this.state.login} control={this.state.control}/>
          {this.state.menu == 'goodsDownload' && <GoodsDownload menu={this.state.menu} />}
          {this.state.menu == 'goodsProduct' && <GoodsProduct menu={this.state.menu} />}
          {this.state.menu == 'push' && <Push menu={this.state.menu} />}
          {this.state.menu == 'notice' && <Notice menu={this.state.menu} />}
          {this.state.menu == 'faq' && <FAQ menu={this.state.menu} />}
          {this.state.menu == 'terms' && <Terms menu={this.state.menu} />}
          {this.state.menu == 'payterms' && <PayTerms menu={this.state.menu} />}
          {this.state.menu == 'privacy' && <Privacy menu={this.state.menu} />}
          {this.state.menu == 'youth' && <Policy menu={this.state.menu} PAGETITLE={'청소년보호정책'} />}    
          {this.state.menu == 'legal' && <Legal menu={this.state.menu} />}
          {this.state.menu == 'cookie' && <Policy menu={this.state.menu} PAGETITLE={'쿠키정책'} />}          
          {this.state.menu == 'payments' && <Payments menu={this.state.menu} />}
          {this.state.menu == 'purchase' && <Purchase menu={this.state.menu} />}
          {this.state.menu == 'purchaseRegList' && <PurchaseRegList menu={this.state.menu} />}
          {this.state.menu == 'purchaseReg' && <PurchaseReg menu={this.state.menu} />}
          {this.state.menu == 'PicturePurchase' && <PicturePurchase menu={this.state.menu} control={this.state.control} />}
          {this.state.menu == 'RequestingPayment' && <PicturePurchase menu={this.state.menu} control={this.state.control} />}
          {this.state.menu == 'PaymentFinished' && <PicturePurchase menu={this.state.menu} control={this.state.control} />}
          {this.state.menu == 'PreparingProduct' && <PicturePurchase menu={this.state.menu} control={this.state.control} />}
          {this.state.menu == 'Shipping' && <PicturePurchase menu={this.state.menu} control={this.state.control} />}
          {this.state.menu == 'DeliveryCompleted' && <PicturePurchase menu={this.state.menu} control={this.state.control} />}
          {this.state.menu == 'banner' && <Banner menu={this.state.menu} />}
          {this.state.menu == 'product' && <Product menu={this.state.menu} />}
          {this.state.menu == 'devices' && <Devices menu={this.state.menu} />}
          {this.state.menu == 'users' && <Users menu={this.state.menu} />}
          {this.state.menu == 'inquiry' && <Inquiry menu={this.state.menu} />}
          {this.state.menu == 'mediareply' && <MediaReply menu={this.state.menu} />}
          {(this.state.menu == 'main' || true) && <Content menu={this.state.menu} onLogin={this.onLogin.bind(this)} login={this.state.login} />}
        </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// src/App.js